import {
  selectBuildingsDamage,
  selectPlayers,
  selectUnits,
} from "../redux/reducers/sharedStateReducer/selectors";
import {selectConstructionPlanEntries} from "../redux/reducers/privateStateReducer/selectors";
import {checkIfConstructionPlanningAvailable} from "../utils/gameState/construction/planning/getConstructionPlanContext";
import {getPlanPlacementIncomeChange} from "../utils/gameState/construction/planning/getPlanPlacementIncomeChange";
import {
  AFFECTED_BUILDING_REVEAL_STAGGER_MS,
  NEARBY_INCOME_CHANGE_DELAY_MS
} from "./playNearbyGuildsTemplesIncomeChangeAnimation";
import {scheduleCityGrowthAnimation} from "./playCityGrowthAnimation";

const checkIfPlanned = (state, hexKey, token) => selectConstructionPlanEntries(state)
  .some((entry) => entry.hexKey === hexKey && entry.token === token);

/**
 * Анимации дохода после постановки строения в план — те же, что после
 * настоящей постройки в свой ход, но на поле «с планом» и от лица самого
 * планирующего (см. getPlanPlacementIncomeChange):
 *  - запланированная гильдия или храм — ее доход и пути влияния (без звука:
 *    звук постановки уже прозвучал, как и в свой ход);
 *  - гильдии и храмы, построенные и запланированные, чей доход изменило
 *    запланированное, — со звуком раскрытия дохода, одной очередью со сдвигом;
 *  - рост города, которому досталась запланированная ячейка, — с доходом и
 *    звуком захвата присоединенных рудников и руин (как playCityGrowthAnimation).
 *
 * Что затронуто, считается сразу, по плану сразу после постановки (как и в
 * playNearbyGuildsTemplesIncomeChangeAnimation): следующая постановка в окне
 * задержки не должна приписать свое изменение этой. Показ отложен — и к нему
 * запланированное могло сняться (двойной клик, отмена, чужая стройка), а
 * планирование — закончиться: тогда показывать нечего.
 *
 * entriesBefore — план до постановки.
 */
export const playPlanPlacementIncomeAnimations = (store, soundManager, hexGridRenderer, placedEntry, entriesBefore) => {
  if (!hexGridRenderer) {
    return;
  }
  const state = store.getState();
  const change = getPlanPlacementIncomeChange(state, placedEntry, entriesBefore);
  if (!change || (!change.placedIncomeBuilding && change.affected.length === 0 && !change.cityGrowth)) {
    return;
  }

  const checkIfPlacedEntryShown = (stateNow) => checkIfConstructionPlanningAvailable(stateNow)
    && checkIfPlanned(stateNow, placedEntry.hexKey, placedEntry.token);

  if (change.cityGrowth) {
    scheduleCityGrowthAnimation(
      state, hexGridRenderer, soundManager, placedEntry.hexKey, change.cityGrowth, change,
      () => checkIfPlacedEntryShown(store.getState())
    );
  }

  const reveals = [
    ...(change.placedIncomeBuilding ? [{...change.placedIncomeBuilding, isPlanned: true, isPlaced: true}] : []),
    ...change.affected,
  ];

  reveals.forEach((reveal, index) => {
    setTimeout(() => {
      const stateNow = store.getState();
      if (!checkIfPlacedEntryShown(stateNow)) {
        return;
      }
      if (reveal.isPlanned && !checkIfPlanned(stateNow, reveal.hexKey, reveal.buildingType)) {
        return;
      }
      if (!reveal.isPlaced) {
        soundManager?.playSpecialBuildingPlacement?.(reveal.buildingType);
      }
      hexGridRenderer.showSpecialBuildingIncomeAnimation(
        reveal.hexKey,
        reveal.buildingType,
        selectPlayers(stateNow),
        change.citiesCache,
        selectUnits(stateNow),
        change.hexes,
        change.specialBuildings,
        selectBuildingsDamage(stateNow),
        change.player
      );
    }, NEARBY_INCOME_CHANGE_DELAY_MS + index * AFFECTED_BUILDING_REVEAL_STAGGER_MS);
  });
};
